import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { FwHttpService } from './fw-http.service';

@Injectable({
  providedIn: 'root'
})
export class KeywordService {

  static prefix = 'keywords';
  public searchResults: Subject<any> = new Subject();
  public searchActive = false;

  constructor(private http: FwHttpService) { }

  public byId(keywordId: number) {
    return this.http.get(`${KeywordService.prefix}/view/${keywordId}.json`)
      .pipe(map(result => result['keyword'][0]))
  }

  public search(q: string, page: number) {
    return this.http.getSearch(`q.php?q=${q}&p=${page}`).pipe(
      tap(data => {
        if (!this.searchActive) {
          history.pushState({ q }, q, `suche/${q}`);
          this.searchActive = true;
        } else {
          history.replaceState({ q }, q, `suche/${q}`);
        }
      }),
    );
  }

}
